import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect';
import moment from 'moment';
import UploadSKBloc from './Blocs/UploadSKBloc';
import { Preview } from '../../../../helpers/ui/FileInput';


const createYearOption = (startYear = 2000) => {
    var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;
    while (startYear <= currentYear) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }
    return years;
}

class IndexView extends Component {

    uploadSKBloc = new UploadSKBloc();

    queryParams = new URLSearchParams(window.location.search)

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            document: null,
            yearOptions: createYearOption(new Date().getFullYear() - 30),
        }
    }

    dateParse = (input) => {
        let res = "";
        if (input != "" && input != null) {
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function (data) {
            var newObj = {};
            newObj["label"] = data[label];
            newObj["value"] = data[value];

            return newObj;
        });
    };

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'file_sk') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.uploadSKBloc.fetchUploadSk(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values,
                uuid: this.state.dataForm.kgb_temp_uuid,
                kgb_employee_uuid: this.state.dataForm.kgb_employee_uuid
            },
            confirm: true
        })
    }
    dateParseYMD = (input) => {
        let res = "";
        if (input != "" && input != null) {
            res = moment(input).format('YYYY-MM-DD')
        }
        return res;
    }
    rupiah = (num) => {
        let res = "-";
        if (num != null && num != '') {
            res = parseFloat(num).toLocaleString('id-ID', { maximumFractionDigits: 2 })
        }
        return res;
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.uploadSKBloc.uploadSkChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.uploadSKBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response

                        // load to form
                        this.setState({
                            dataForm: response,
                            document: response.document_sk
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.uploadSKBloc.fetchDetail({ kgb_temp_uuid: this.queryParams.get('uuid') })
    }

    componentWillUnmount() {
        this.uploadSKBloc.uploadSkChannel.unsubscribe()
        this.uploadSKBloc.detailChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Detail Data Kenaikan Gaji Berkala</CardTitle>
                                    {/* <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle> */}
                                    <hr />


                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Nama Pegawai
                                            </label>
                                            <Col md="4">
                                                <AvField
                                                    name="kgb_temp_employee_name"
                                                    placeholder=""
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.kgb_temp_employee_name}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                NIP Pegawai
                                            </label>
                                            <Col md="4">
                                                <AvField
                                                    name="kgb_temp_employee_nip"
                                                    placeholder=""
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.kgb_temp_employee_nip}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Golongan/Ruang
                                            </label>
                                            <Col md="4">
                                                <AvField
                                                    name="kgb_temp_golongan_ruang"
                                                    placeholder=""
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.kgb_temp_golongan_ruang}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Masa Kerja
                                            </label>
                                            <Col md="4">
                                                <AvField
                                                    name="kgb_temp_masa_kerja_tahun"
                                                    placeholder=""
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={`${this.state.dataForm?.kgb_temp_masa_kerja_tahun || 0} Tahun ${this.state.dataForm?.kgb_temp_masa_kerja_bulan || 0} Bulan`}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Gaji Baru
                                            </label>
                                            <Col md="4">
                                                <AvField
                                                    name="kgb_temp_gaji_pokok_baru"
                                                    placeholder=""
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.rupiah(this.state.dataForm.kgb_temp_gaji_pokok_baru)}
                                                />
                                            </Col>
                                        </Row>

                                        <hr />

                                        {/* <Row className="mb-3">
                                                <label
                                                    htmlFor="no_sk"
                                                    className="col-md-3 col-form-label"
                                                >
                                                Nomor Persetujuan Teknis BKN <span className="text-danger">*</span>
                                                </label>
                                                <Col md="3">
                                                        <AvField
                                                        name="kgb_pertek_bkn_number"
                                                        id="kgb_pertek_bkn_number"
                                                        placeholder="Nomor Persetujuan Teknis BKN"
                                                        type="text"
                                                        errorMessage="Masukan Nomor Persetujuan Teknis BKN"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        value={this.state.dataForm?.kgb_pertek_bkn_number}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>  

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor="no_sk"
                                                    className="col-md-3 col-form-label"
                                                >
                                                Tanggal Persetujuan Teknis BKN <span className="text-danger">*</span>
                                                </label>
                                                <Col md="4">
                                                        <AvField
                                                        name="kgb_pertek_bkn_date"
                                                        id="kgb_pertek_bkn_date"
                                                        placeholder="Tanggal Persetujuan Teknis BKN"
                                                        type="date"
                                                        errorMessage="Masukan Tanggal Persetujuan Teknis BKN"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        value={this.state.dataForm?.kgb_pertek_bkn_date}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>  

                                        <hr /> */}

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Nomor SK KGB <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <AvField
                                                    name="kgb_temp_sk_baru"
                                                    id="kgb_temp_sk_baru"
                                                    placeholder="Nomor SK KGB"
                                                    type="text"
                                                    readonly="readonly"
                                                    errorMessage="Masukan Nomor SK KGB"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.kgb_temp_sk_baru}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Tanggal SK KGB <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <AvField
                                                    name="kgb_temp_tanggal_sk_baru"
                                                    id="kgb_temp_tanggal_sk_baru"
                                                    placeholder="Tanggal SK KGB"
                                                    type="date"
                                                    readonly="readonly"
                                                    errorMessage="Masukan Tanggal SK KGB"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.dateParseYMD(this.state.dataForm.kgb_temp_tanggal_sk_baru)}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                TMT SK KGB <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <AvField
                                                    name="kgb_temp_tmt_sk_baru"
                                                    id="kgb_temp_tmt_sk_baru"
                                                    placeholder="TMT SK KGB"
                                                    type="date"
                                                    readonly="readonly"
                                                    errorMessage="Masukan TMT SK KGB"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.dateParseYMD(this.state.dataForm.kgb_temp_tmt_sk_baru)}
                                                />
                                            </Col>
                                        </Row>


                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                File SK KGB
                                            </label>
                                            <Col md="8">
                                                {
                                                    this.state.document ?
                                                        <>
                                                            {this.state.document !== null ?
                                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document?.documents_path}>
                                                                    Download <i className="fa fa-download ms-1"></i>
                                                                </a>
                                                                : '-'}
                                                        </>
                                                        :
                                                        <Shimmer><div style={{ width: '30%', height: 15 }}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>


                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to={`/kepegawaian/kgb.html?pegawai&uuid=${this.queryParams.get('period_uuid')}`}>
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {/* {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button> */}
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect ?
                    <Redirect to={`/kepegawaian/kgb.html?pegawai&uuid=${this.queryParams.get('period_uuid')}`} />
                    : null}
            </Fragment>
        )
    }

}

export default IndexView